const badge_fragment = /* glsl */ `
#include <common>
#include <fog_pars_fragment>

uniform sampler2D t1;
uniform sampler2D t2;
uniform sampler2D t3;
uniform float transition1;
uniform float transition2;
uniform sampler2D uDisplacement;
varying vec2 vUv;

void main(){
    vec4 tex1 = texture2D(t1, vUv);
    vec4 tex2 = texture2D(t2, vUv);
    vec4 tex3 = texture2D(t3, vUv);

    float threshold = 0.01;

    vec4 transitionTexel = texture2D(uDisplacement, vUv);
    float r = transition2 * (1.0 + threshold * 2.0) - threshold;
	float mixf = clamp((transitionTexel.r - r)*(1.0/threshold), 0.0, 1.0);

    // Mixing the textures
    vec4 col = mix(tex1, tex2, transition1);
    col = mix(tex3, col, mixf);

    // Gamma Correction
    col.rgb = pow(col.rgb, vec3(1.0 / 2.2));

    gl_FragColor = col;
    #include <fog_fragment>
}
`

export default badge_fragment